export const BILL_ICON = "cart_two_dot_o/Bill.png";

export const BILL_ICON_SIZE = "20px";
export const BILL_UPSELL_ICON_SIZE = "20px";

export const COLLAPSIBLE_BILL_TOOL_TIP_IMG_CLASS = "tool-tip-image";
export const COLLAPSIBLE_BILL_TOOL_TIP_IMG_SIZE = "15px";

export const POSITIVE_GREEN_SUPPORTED_KEYS = [
    "platform_fee_tax_inclusive",
    "partial_platform_fee_tax_inclusive",
    "free_platform_fee_tax_inclusive",
];

export const ACCESSIBILITY_TEXTS = {
    KILOMETRE: " kilometres. ",
    RUPEE: " Rupees",
};

export const DISCOUNT_TYPES = {
    SUPER: "SUPER",
};

export const TEXTS = {
    YOU_SAVE: "You save",
};

export const META_TYPES = {
    DATATYPE: {
        STRING: "string",
    },
    ALIGN: {
        LEFT: "left",
        RIGHT: "right",
    },
    WINDOW_WIDTH: {
        L: "150",
        XL: "200",
        XXL: "240",
        XXXL: "270",
    },
};

export const LINE_ITEM_LOGO_ID = "logoId";
export const INFO_TEXT_LOGO_ID = "icon";

export const META_TYPES_V4 = {
    DATATYPE: {
        STRING: "string",
    },
    ALIGN: {
        LEFT: "left",
        RIGHT: "right",
    },
    WINDOW_WIDTH: {
        L: "180",
        XL: "230",
        XXL: "240",
        XXXL: "270",
    },
};
